import React from 'react';
import { useSelector } from 'react-redux';
import { TemplateType, TemplateThemePaths, } from '@debbie/common/dist/templates/index.js';
import { Modal, Input, Select } from '../../index.js';
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
const SettingsModal = (props) => {
    const allCreditorsLoadable = useAllCreditors();
    const allCreditors = h.hasData(allCreditorsLoadable)
        ? allCreditorsLoadable.data
        : null;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Modal, { header: "Settings", onToggle: props.toggleSettingsModal },
        React.createElement("h3", null, lang.templates.creditor),
        React.createElement("p", null, lang.templates.ifCreditorSelected),
        React.createElement(Select, { value: props.template.creditorId, onChange: (e) => {
                props.setTemplate({
                    ...props.template,
                    creditorId: e.target.value !== '' ? e.target.value : null,
                });
            } },
            React.createElement("option", { value: "" },
                "-- ",
                lang.templates.selectCreditor,
                " --"),
            allCreditors &&
                allCreditors.map((c) => (React.createElement("option", { key: c.creditorId, value: c.creditorId }, c.name)))),
        props.template &&
            [TemplateType.LETTER, TemplateType.EBOKS].includes(props.template.type) && (React.createElement("div", null,
            React.createElement("h3", null, lang.templates.letterTheme),
            React.createElement("p", null, lang.templates.ifThemeSelected),
            React.createElement(Select, { value: props.template.templateTheme, onChange: (e) => {
                    props.setTemplate({
                        ...props.template,
                        templateTheme: e.target.value,
                    });
                } },
                React.createElement("option", { value: "" },
                    "-- ",
                    lang.templates.selectTheme,
                    " --"),
                React.createElement("option", { value: TemplateThemePaths.PLAIN }, TemplateThemePaths.PLAIN),
                React.createElement("option", { value: TemplateThemePaths.PLAIN_WITH_LOGO }, TemplateThemePaths.PLAIN_WITH_LOGO),
                React.createElement("option", { value: TemplateThemePaths.PLAIN_WITH_HEADER }, TemplateThemePaths.PLAIN_WITH_HEADER),
                React.createElement("option", { value: TemplateThemePaths.PLAIN_WITH_HEADER_CREDITORS }, TemplateThemePaths.PLAIN_WITH_HEADER_CREDITORS),
                React.createElement("option", { value: TemplateThemePaths.PLAIN_RKI }, TemplateThemePaths.PLAIN_RKI),
                React.createElement("option", { value: TemplateThemePaths.PLAIN_RKI_DEBITOR_REGISTRET }, TemplateThemePaths.PLAIN_RKI_DEBITOR_REGISTRET)),
            props.template &&
                [TemplateType.LETTER].includes(props.template.type) && (React.createElement(Input, { placeholder: lang.templates.fileName, value: props.template.fileName ?? undefined, onChange: (e) => {
                    props.setTemplate({
                        ...props.template,
                        fileName: e.target.value,
                    });
                } }))))));
};
export default SettingsModal;
//# sourceMappingURL=SettingsModal.js.map